export default "__VITE_ASSET__ezSfOb5e__"